export enum ComponentNameEnum {
  AccountSelection,
  TellUsAboutYourself,
  EmploymentDetails,
  PromoCode,
  BSAProfile,
  PersonalDetails
}
